export type CartRuleProduct={precio_venta:number;controla_stock:boolean;producto_stock?:Array<{cantidad:number}>};

export const canSell=(product:CartRuleProduct)=>!product.controla_stock||(product.producto_stock?.[0]?.cantidad||0)>0;

export const nextQuantity=(product:CartRuleProduct,current:number)=>{
  const requested=Math.max(0,current+1);
  return product.controla_stock?Math.min(product.producto_stock?.[0]?.cantidad||0,requested):requested;
};

export const cartTotal=<T extends CartRuleProduct>(lines:Array<{producto:T;cantidad:number}>)=>
  lines.reduce((sum,line)=>sum+line.producto.precio_venta*Math.max(0,line.cantidad),0);

export type DiscountMode='amount'|'percentage';

export const calculateDiscount=(subtotal:number,mode:DiscountMode,value:number)=>{
  const safeSubtotal=Math.max(0,Math.round(Number(subtotal)||0));
  const safeValue=Math.max(0,Number(value)||0);
  const requested=mode==='percentage'
    ? Math.round(safeSubtotal*safeValue/100)
    : Math.round(safeValue);
  return Math.min(safeSubtotal,requested);
};

export const saleTotal=(subtotal:number,discount:number)=>
  Math.max(0,Math.round(Number(subtotal)||0)-Math.max(0,Math.round(Number(discount)||0)));

export const expectedCash=(initial:number,cashSales:number,incomes:number,withdrawals:number)=>
  Math.max(0,initial)+Math.max(0,cashSales)+Math.max(0,incomes)-Math.max(0,withdrawals);
